<template>
  <div class="foters">
    <div class="form">
      <a-form :layout="formLayout">
        <a-row :gutter="24" type="flex" justify="start" >
          <a-col :span="6" class="fl fw">
            <a-form-item
              label="账户名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入账户名称"
                v-model="conditionLike.accountName"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" class="fl1 fw">
            <a-form-item
              label="账户编号"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-input
                placeholder="请输入账户编号"
                :allowClear="true"
                v-model="conditionLike.accountNo"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4" class="oper">
            <div style="padding-top: 2.4%;margin-left: 12px;">
            <a-button class="btone" @click="queryList(1) ">查询</a-button>
          </div>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 展示内容 -->
    <div class="base-content">
      <!-- 表格 -->
      <div>
        <a-table
          :columns="columns"
          :scroll="{ x: 1000, y: 'calc(100vh - 340px)' }"
          :data-source="tableData"
          :pagination="false"
          :loading="Tableloading"
          :rowKey="
            (record, index) => {
              return record.id
            }
          "
          bordered
          size="small"
          
        >
          <span slot="index" slot-scope="text, record, index">
            {{index + (pageNum-1) * pageSize + 1}}
          </span>
          <span slot="lastConsumedTime" slot-scope="text">
            {{ toDate(text) }}
          </span>
          <div slot="action" slot-scope="text">
            <a-button class="btaction"  @click="recharge(text)">
              充值
              </a-button>
              <a-button class="btaction" style="margin-left: 10px;" @click="giftRoll(text)">赠送权益券</a-button>
          </div>
          
        </a-table>
      </div>
      <!-- 分页 -->
      <div class="base-pagination">
        <div class="total-view">
          共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPage }}页
        </div>
        <div class="pagination-buttons">
          <a-pagination
            v-model="pageNum"
            :total="totalRows"
            :current="pageNum"
            :defaultPageSize="pageSize"
            show-less-items
            @change="changePageFn($event)"
          />
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <addModal
      v-if="visibleAdd"
      :visible="visibleAdd"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></addModal>
    <refundModal
      v-if="visibleBatch"
      :visible="visibleBatch"
      :userData="userData"
      :type="type"
      :title="title"
      @close="reflush"
      @queryList="queryList"
    ></refundModal>




    <a-modal
        v-model="visible"
        width="1000px"
        :destroyOnClose="true"
        :maskClosable="false"
        v-if="visible"
        :closable="false"
      >
      <div slot="title" class="tip-icon"> 赠送权益卷 </div>
      <template slot="footer" slot-scope="text">
          <a-button
            style="margin-right: 15px;"
            key="submit"
            class="btaction"
            :loading="addMembConfLoading"
            @click="addMemberbenefits"
            :disabled="disabled"
          >
            确认
          </a-button>
          <a-button
            class="btaction"
            @click="handleCancel()"
            :disabled="disabled"
          >
            取消
          </a-button>
        </template>
        <a-button class="bttwo" @click="addItem()">新增</a-button>
    <a-table
          :columns="columns1"
          :data-source="data1"
          bordered
          style="margin-top: 10px"
          :pagination="false"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 }}
          </span>
          <span slot="equGoodName" slot-scope="text, record">
            {{ record.equGoodName }}
          </span>
          <template
            v-for="col in [
              'equId',
              'category',
              'count',
              'equCategory',
              'remark',
              'operation',
            ]"
            :slot="col"
            slot-scope="text, record"
          >
            <div :key="col">

              <a-select
                placeholder="请输选择"
                v-if="col == 'category'"
                v-model="record.category"
                style="width: 120px"
              >
                <a-select-option
                  v-for="item in vipcommodity"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>

              <a-select
                placeholder="请选择"
                v-if="col == 'equCategory'"
                v-model="record.equCategory"
                style="width: 120px"
              >
                <a-select-option
                  v-for="item in commodity"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.label }}</a-select-option
                >
              </a-select>

              <div v-if="record.equCategory == '2'">
                <a-input
                :disabled="record.equCategory == '2'"
                v-if="col == 'count'"
                style="margin: -5px 0"
                />
              </div>
              <div v-else>
                <a-input
                type="number"
                placeholder="请输入"
                v-if="col == 'count'"
                style="margin: -5px 0"
                v-model="record.count"
                :value="text"
                />
              </div>
            </div>
          </template>
          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
              <span>
                <a-button class="bttwo" @click="() => deleteItem(text, record)"
                  >删除</a-button
                >
              </span>
            </div>
          </template>
        </a-table>
         <!-- 新增商品名称 -->
         <a-modal
          v-model="visible2"
          class="modal"
          width="800px"
          :maskClosable="false"
          @cancel="handleCancelGood(false)"
        >
        <div slot="title" class="tip-icon"> {{title2}} </div>
          <!-- 展示内容 -->
          <div class="base-content">
            <!-- 表格 -->
            <a-table
              :columns="columns2"
              :rowKey="record=>record.id"
              :data-source="tableData2"
              :pagination="false"
              bordered
              size="small"
              :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
              }"
              :scroll="{ x: 700, y: 'calc(100vh - 300px)' }"
              class="table"
            >
              <span slot="index1" slot-scope="text, record, index">
                {{ index + (pageNum1 - 1) * pageSize1 + 1 }}
              </span>
              <span slot="expiryDate" slot-scope="text, record">
                {{ record.expiryDate | DictionaryFilter("GOOD_VALIDITY") }}
              </span>
            </a-table>

            <!-- 分页 -->
            <div class="base-pagination">
              <div class="total-view">
                共{{ totalRows1 }}条数据，第{{ pageNum1 }}/{{ totalPages1 }}页
              </div>
              <div class="pagination-buttons">
                <a-pagination
                  v-model="pageNum1"
                  :total="totalRows1"
                  :defaultPageSize="pageSize1"
                  show-less-items
                  @change="changePage($event)"
                />
              </div>
            </div>
          </div>
          <template #footer>
            <!-- 底部按钮区域 -->
            <a-button class="btaction" @click="addEquityGoodFn"
              >确 定</a-button
            >
          </template>
        </a-modal>
         </a-modal>
  </div>
</template>

<script>
import {
  accountQueryAll,
  goodList,
  giveEquity
} from '@/api/api.js'
import addModal from './account-modal.vue'
import refundModal from './account-refund-modal.vue'

import { DictionaryService } from '../../../../common/services/dictionary.service'
export default {
  name: 'accountManagement',
  components: {
    addModal: addModal,
    refundModal:refundModal,
  },
  data() {
    return {
      formLayout: 'horizontal',
      data1: [],
      tableData2: [],
      visible:false,
      conditionLike: {
        accountNo: '',
        accountName: '',
      },
      Tableloading: false,
      tableData: [],
        //数列1
        columns1: [
        {
          title: "序号",
          align: "center",
          dataIndex: "index1",
          width: 60,
          key: "index1",
          ellipsis: true,
          scopedSlots: { customRender: "index" },
        },
        {
          title: "权益商品名称",
          dataIndex: "equGoodName",
          key: "equGoodName",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "equGoodName" },
        },
        {
          title: "类别",
          dataIndex: "category",
          key: "category",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "category" },
        },
        {
          title: "权益类别",
          dataIndex: "equCategory",
          key: "equCategory",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "equCategory" },
        },

        {
          title: "数量",
          dataIndex: "count",
          key: "count",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "count" },
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          scopedSlots: {
            customRender: "operation",
          },
        },
      ],
      //数列2
      columns2: [
        {
          title: "权益商品编号",
          dataIndex: "goodCode",
          key: "goodCode",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "goodCode" },
        },

        {
          title: "权益商品名称",
          dataIndex: "goodName",
          key: "goodName",
          align: "center",
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: "goodName" },
        },

        {
          title: "权益商品单价",
          dataIndex: "goodPrice",
          key: "goodPrice",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "goodPrice" },
        },
        {
          title: "有效期",
          dataIndex: "expiryDate",
          key: "expiryDate",
          align: "center",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "expiryDate" },
        },
      ],
      columns: [
        {
          title: "序号",
          align: "center",
          dataIndex: 'index',
          width: 40, key: 'index',
          ellipsis: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '账户编号',
          align: 'center',
          dataIndex: 'accountNo',
          width: 100,
          key: 'accountNo',
          ellipsis: true,
          scopedSlots: { customRender: 'accountNo' },
        },
        {
          title: '账户名称',
          align: 'center',
          dataIndex: 'accountName',
          width: 100,
          key: 'accountName',
          ellipsis: true,
          scopedSlots: { customRender: 'accountName' },
        },
        {
          title: '账户余额(元)',
          align: 'center',
          dataIndex: 'accountAmount',
          width: 100,
          key: 'accountAmount',
          ellipsis: true,
          scopedSlots: { customRender: 'accountAmount' },
        },
        {
          title: '累计消费额(元)',
          align: 'center',
          dataIndex: 'upConsumedAmount',
          width: 100,
          key: 'upConsumedAmount',
          ellipsis: true,
          scopedSlots: { customRender: 'upConsumedAmount' },
        },
        {
          title: '累计充值额(元)',
          align: 'center',
          dataIndex: 'upRechargeAmount',
          width: 100,
          key: 'upRechargeAmount',
          ellipsis: true,
          scopedSlots: { customRender: 'upRechargeAmount' },
        },
        {
          title: '累计申请退款额(元)',
          align: 'center',
          dataIndex: 'upRefundAmount',
          width: 100,
          key: 'upRefundAmount',
          ellipsis: true,
          scopedSlots: { customRender: 'upRefundAmount' },
        },
        {
          title: '最后消费日期',
          align: 'center',
          dataIndex: 'lastConsumedTime',
          width: 100,
          key: 'lastConsumedTime',
          ellipsis: true,
          scopedSlots: { customRender: 'lastConsumedTime' },
        },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          width: 140,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      visible2:false,
     title2:'',
      // // 分页相关
      pageNum: 1,
      pageSize: 10,
      totalRows: null,
      totalPage: '',
      //新增弹框
      visibleAdd: false,
      visibleBatch: false,
      userData: {},
      type: '',

      pageNum1: 1,
      pageSize1: 10,
      totalRows1: 0,
      totalPages1: 0,
      disabled: false,
     //新增会员确认加载
      addMembConfLoading: false,
      selectedRowKeys: [],
      selectedRows: [],
      vipcommodity: [],
      commodity: [],
      openid:''
    }
  },
  activated() {
    //查询列表
    
    DictionaryService.getAllNeedDic([
      // "MEM_STATUS",
      // "MEM_DISCOUNT",
      "GRANT_TYPE",
      "MEM_PG_CLASS",
      // "GOOD_VALIDITY",
    ]).then((res) => {
      // this.dictStatus = DictionaryService.getOptions("MEM_STATUS");
      this.commodity = DictionaryService.getOptions("GRANT_TYPE");
      this.vipcommodity = DictionaryService.getOptions("MEM_PG_CLASS");
      // this.goodValidity = DictionaryService.getOptions("GOOD_VALIDITY");
      this.queryList(1);
    });
  },
  mounted() {
    
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }
        : {}
    },
    buttonItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
            wrapperCol: { span: 6, offset: 18 },
          }
        : {}
    },
  },
  methods: {
     //关闭选择权益商品选中行
     handleCancelGood(e) {
      this.selectedRowKeys = [];

      //页面重置为第一页
      this.changePage(1);
    },
    giftRoll(text) {
      console.log(text, '---------')
      this.openid = text.openid
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.data1 = []
      this.selectedRows = [];
      this.tableData2 = []
    },
    addItem(key) {
      this.visible2 = true;
      this.title2 = "选择权益商品名称";
      this.querygoodList();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = this.selectedRows.concat(selectedRows);
       //去重
       var result = [];
      var obj = {};
      for (var i = 0; i < this.selectedRows.length; i++) {
        if (!obj[this.selectedRows[i].id]) {
          result.push(this.selectedRows[i]);
          obj[this.selectedRows[i].id] = true;
        }
      }
      this.selectedRows = result;
console.log(this.selectedRows,'this.selectedRows')
      this.selectedRowKeys = selectedRowKeys;

      console.log(this.selectedRowKeys,'ssss')
      // this.selectedRows.forEach((item) => {
      //   this.goodNameee = item.goodName;
      //   this.id = item.id;
      // });
    },
    // 确定新增 + 编辑
    addMemberbenefits(e) {
      console.log(this.data1, '--')
      let equityGoodDetailList = [];
      this.addMembConfLoading = true;
      let list = {};
      this.data1.forEach((item) => {
        if (item.equCategory == '2') {
          item.count = undefined;
        }
        list = {
          category: item.category,
          count: item.count,
          equCategory: item.equCategory,
          equId: item.equId,
          equGoodName: item.equGoodName,
        };
        equityGoodDetailList.push(list);
      });
      let isAll = equityGoodDetailList.some((item) => {
        if (item.category == undefined || item.equCategory == undefined) {
          return true;
        }
        if (item.equCategory == "1" && item.count == undefined) {
          return true;
        }
      });
      if (isAll) {
        this.$message.error("请补全权益商品信息");
        this.addMembConfLoading = false;
        return;
      }
      let isCount = equityGoodDetailList.some((item) => {
        if(item.count != undefined){
          if (Number(item.count) <= 0) {
            return true;
          } else if (!Number.isInteger(Number(item.count))) {
            return true;
          }
        }
      });
      if (isCount) {
        this.$message.error("请输入权益商品数量为整数并且大于0");
        this.addMembConfLoading = false;
        return;
      }
      if (equityGoodDetailList.length <= 0) {
          this.$message.error("请选择权益商品");
          this.addMembConfLoading = false;
          return;
      }
      giveEquity({ "openId": this.openid, "equityGoodDetailList": equityGoodDetailList }).then(res => {
        this.$message.success("修改成功");
        this.visible = false;
                this.data1 = [];
        this.selectedRows = [];
        this.addMembConfLoading = false;
      }, (err) => {
        this.visible = false;
        this.addMembConfLoading = false;
    })
    },
    //删除权益商品信息
    deleteItem(key) {
      //删除复选框中的值
      if(this.selectedRows.length != 0){
        for (let i = 0; i<this.selectedRows.length; i++){
          if (this.selectedRows[i].equId == key.equId){
            this.selectedRows.splice(i, 1);
          }
        }
      }
      if (this.data1.length === 0) {
        return;
      }
      //删除修改复选数据
      for (let i = 0; i<this.data1.length; i++){
        if (this.data1[i].equId == key.equId){
          this.data1.splice(i, 1);
        }
      }
    },
    //新增权益
    addEquityGoodFn() {
      //根据key值选取选中商品
      let selectedRowsMed = this.selectedRows;
      this.selectedRows = [],
        this.selectedRowKeys.forEach((item) => {
          selectedRowsMed.forEach((itmeRows) => {
            if (item === itmeRows.id) {
              this.selectedRows.push(itmeRows)
            }
          })
        });

      this.visible2 = false;
      this.selectedRowKeys = [];
      console.log(this.selectedRows,'.selectedRows')
      this.data1 = this.data1.concat(this.selectedRows);
console.log(this.data1,'----')
      //统一名称
      this.data1.forEach((item) => {
        item.equGoodName = item.goodName || item.equGoodName;
        item.equId = item.id || item.equId;
      });

      //去重
      var result = [];
        var obj = {};
        for (var i = 0; i < this.data1.length; i++) {
          if (!obj[this.data1[i].equId]) {
            result.push(this.data1[i]);
            obj[this.data1[i].equId] = true;
          }
        }
      this.data1 = result;

      //重置新增商品页面为第一页
      this.changePage(1);
    },
    changePage(event) {
      this.pageNum1 = event;
      this.querygoodList();
    },
      //查询商品名称
      querygoodList(sum = 2) {
      if (sum == 1) this.pageNum1 = 1;
      let obj = {
        pageParam: {
          pageNum: this.pageNum1,
          pageSize: this.pageSize1,
          orderBy: "",
        },
        content: {
          goodCode: this.goodCode,
          goodName: this.goodName,
        },
      };
      goodList(obj).then(
        (res) => {
          this.tableData2 = res.content.rows;

          this.totalRows1 = res.content.page.totalRows;
          this.totalPages1 = Math.ceil(this.totalRows1 / this.pageSize1);
        },
        (err) => {}
      );
    },
    // 分页修改
    changePageFn(event) {
      this.pageNum = event
      this.queryList()

    },
    // 获取表格数据
    queryList(sum = 2) {
      if (sum == 1) this.pageNum = 1
      this.Tableloading = true
      let pageParam = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderBy: '',
      }
      accountQueryAll({ pageParam: pageParam, content: this.conditionLike }).then(
        (res) => {
          this.Tableloading = false
          this.tableData = res.content.rows
          this.totalRows = res.content.page.totalRows
          this.totalPage = Math.ceil(this.totalRows / this.pageSize)
        },
        (err) => {
          this.$message.error('查询失败')
          this.Tableloading = false
        }
      )
    },
    // 关闭弹窗
    reflush(value) {
      this.visibleAdd = value
      this.visibleBatch = value
      this.selectedRowKeys = []
    },
    //更多操作-通过
    recharge(data) {
      this.visibleAdd = true
      this.userData = data
      this.title = '账户充值' 
    },

    //更多操作-拒绝
    accountRefund(data) {
      this.visibleBatch = true
      this.userData = data
      this.title = '账户退款'
    },
        // 时间戳转化日期
    toDate(date) {
      if (date == null) {
        return "";
      } else {
        let date1 = new Date(date);
        let time = this.formatDate(date1);
        return time;
      }
    },
    formatDate(value) {
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
  }
}
</script>

<style lang="less" scoped="scoped">
.foters {
  width: 100%;
  height: 100%;
  .title-name {
    width: 100%;
    height: 100px;
    overflow: hidden;
    .sp_name {
      display: inline-block;
      font-size: 20px;
      margin: 0 0 20px 10px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex label {
    font-size: 16px;
    width: 73px;
  }
  .btone {
    margin-right: 12px;
  }
  /deep/.ant-table-thead {
    background-color: #dcf4ff;
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  a {
    margin-left: 10px;
  }
  a:hover {
    color: #70b9cf;
  }
}

/deep/ .ant-table-body {
  //   max-height: 487px;
  //   overflow: auto;
  // margin: 0 !important;
}
/deep/.ant-table-tbody > tr > td {
  padding: 11px 16px;
}
/deep/ .form .ant-input,.ant-select,.ant-form-item-control,.ant-form-item-control-wrapper{
  width: 160px;
}
.fw {
  width: 236px;
}
.oper{
  // flex: 1;
  width: 200px;
}
.plan{
  width: 350px;
}
.ant-row{
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1){
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1){
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1){
  width: 75px;
}
/deep/ .ant-col-18 {
  width: 75%;
}
</style>
